// NavBar.js - Professional Navigation Component
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaUser, FaSignOutAlt, FaCog } from 'react-icons/fa';
import './NavBar.css';
import wiproLogo from './assets/wipro.png';
import traneLogo from './assets/trane-logo.svg';
import notificationIcon from './assets/notification.svg';

const NavBar = ({ userName = "John Doe", userEmail = "user@example.com", onLogout }) => {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Left: Logos and Brand - matching login page */}
        <div className="navbar-brand">
          <img src={traneLogo} alt="Trane Technologies" className="navbar-logo trane-nav-logo" />
          <span className="navbar-title">AGENT ASSIST</span>
          <span className="powered-by-text">Powered by</span>
          <img src={wiproLogo} alt="Wipro" className="navbar-logo wipro-nav-logo" />
        </div>

        {/* Center: Navigation Links */}
        <div className="navbar-links">
          <Link 
            to="/AgentAssist" 
            className={`nav-link ${isActive('/AgentAssist') ? 'active' : ''}`}
          >
            📊 Dashboard
          </Link>
          <Link 
            to="/analytics" 
            className={`nav-link ${isActive('/analytics') ? 'active' : ''}`}
          >
            📈 Analytics
          </Link>
        </div>

        {/* Right: User Actions */}
        <div className="navbar-actions">
          {/* Notifications */}
          <div className="notification-container">
            <button 
              className="navbar-icon-btn" 
              title="Notifications"
              onClick={() => setShowNotifications(!showNotifications)}
            >
              <img src={notificationIcon} alt="Notifications" style={{ width: '20px', height: '20px' }} />
              <span className="notification-badge">3</span>
            </button>
            
            {showNotifications && (
              <div className="notification-dropdown">
                <div className="notification-header">
                  <h3>Notifications</h3>
                  <button className="mark-read-btn">Mark all as read</button>
                </div>
                <div className="notification-list">
                  <div className="notification-item unread">
                    <div className="notification-icon">🎫</div>
                    <div className="notification-content">
                      <p className="notification-text">New ticket assigned: INC1234</p>
                      <span className="notification-time">5 minutes ago</span>
                    </div>
                  </div>
                  <div className="notification-item unread">
                    <div className="notification-icon">✅</div>
                    <div className="notification-content">
                      <p className="notification-text">Ticket INC1230 resolved</p>
                      <span className="notification-time">1 hour ago</span>
                    </div>
                  </div>
                  <div className="notification-item">
                    <div className="notification-icon">📊</div>
                    <div className="notification-content">
                      <p className="notification-text">Weekly report available</p>
                      <span className="notification-time">2 hours ago</span>
                    </div>
                  </div>
                </div>
                <div className="notification-footer">
                  <button className="view-all-btn">View all notifications</button>
                </div>
              </div>
            )}
          </div>

          {/* User Profile Dropdown */}
          <div className="user-menu-container">
            <button 
              className="user-profile-btn"
              onClick={() => setShowUserMenu(!showUserMenu)}
            >
              <div className="user-avatar">
                <FaUser />
              </div>
              <span className="user-name">{userName}</span>
              <span className="dropdown-arrow">▼</span>
            </button>

            {showUserMenu && (
              <div className="user-dropdown">
                <div className="dropdown-header">
                  <div className="user-avatar-large">
                    <FaUser />
                  </div>
                  <div className="user-info">
                    <div className="user-name-large">{userName}</div>
                    <div className="user-email">{userEmail}</div>
                  </div>
                </div>
                <div className="dropdown-divider"></div>
                <button className="dropdown-item">
                  <FaCog /> Settings
                </button>
                <button className="dropdown-item logout-item" onClick={onLogout}>
                  <FaSignOutAlt /> Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
